import { useLocalStorage } from '@obvio/app'
import { useCallback, useMemo } from 'react'

type UseLocalStorage = {
  registeredEvents: string[] | undefined
  registerEvent: (id: string) => void
  removeEvent: (id: string) => void
}

export function useLocalStorageEvent(): UseLocalStorage {
  const [registeredEvents, setRegisteredEvents] = useLocalStorage<string[]>(
    `event-register`,
    [],
  )

  const registerEvent = useCallback(
    (id: string) =>
      setRegisteredEvents((currentValue) => [...currentValue, id]),
    [setRegisteredEvents],
  )

  const removeEvent = useCallback(
    (id: string) =>
      setRegisteredEvents((currentValue) =>
        currentValue.filter((cId) => cId !== id),
      ),
    [setRegisteredEvents],
  )

  return useMemo(
    () => ({ registerEvent, removeEvent, registeredEvents }),
    [registerEvent, registeredEvents, removeEvent],
  )
}
